export type StatusTone = 'neutral' | 'success' | 'warning' | 'error' | 'accent' | 'confirm';

/** Цвет точки статуса; нужен и тем, кто рисует точку без пилюли. */
export const STATUS_DOT_CLASSES: Record<StatusTone, string> = {
  neutral: 'bg-(--base-secondary-text-color)',
  success: 'bg-(--base-success-color)',
  warning: 'bg-(--base-warning-color)',
  error: 'bg-(--base-error-color)',
  accent: 'bg-(--base-accent-color)',
  confirm: 'bg-(--base-confirm-color)',
};
